// removed by extract-text-webpack-plugin
module.exports = {"title":"PopinKbaInfo-module-title-2-ERF","description":"PopinKbaInfo-module-description-viuij","img":"PopinKbaInfo-module-img-2DoSv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopinKbaInfo/PopinKbaInfo.module.scss
// module id = 1054
// module chunks = 0